/* global X2JS embedpano*/
import api from '@/api';
import Vue from 'vue';
import utils from "@/utils/utils";

const x2js = new X2JS();
let baseXml = null;

export default {
  //组装-加载-krpano
  async loadPano(krpano, data, blend = null, flags = null, loaddone = null) {
    baseXml = baseXml || (await this.getXml());
    let sceneXml = this.getSceneXml(data);
    let hsXml = this.getHsXml(data.extra.spotList);
    let hsPlaceholderXml = this.getHsPlaceholderXml(data.extra.spotList);
    let hsTitleXml = this.getHsTitleXml(data.extra.spotList);
    let hsDescXml = this.getHsDescXml(data.extra.spotList);
    // let hsLineXml = this.getPolylineXml(data.extra.pointList);
    sceneXml.hotspot = [...hsXml, ...hsPlaceholderXml];
    sceneXml.layer = [...hsTitleXml, ...hsDescXml];
    baseXml.krpano.scene = sceneXml;
    this.loadPanoXml(krpano, baseXml, blend, flags, loaddone, data);
    return krpano;
  },

  //初始化-krpano
  initKrpano(id) {
    return new Promise((resolve) => {
      let vars = {};
      vars.syncviewer = id === 'pano' ? 'krpanoSWFObjectpanoCompare' : 'krpanoSWFObjectpano';
      embedpano({
        id: 'krpanoSWFObject' + id,
        xml: null,
        target: id,
        vars,
        html5: 'only+webgl+preserveDrawingBuffer',
        mobilescale: 1.0,
        passQueryParameters: false,
        consolelog: true,
        onready: (krpano) => {
          resolve(krpano);
        },
      });
    });
  },

  //krpano-基础-xml-加载
  async getXml() {
    let res = await api.krpano.getIndexXml();
    let xmlDoc = res.request.responseXML;
    let jsonXml = x2js.xml2json(xmlDoc);
    jsonXml.krpano._debugmode = process.env.NODE_ENV == 'development';
    jsonXml.krpano._showerrors = process.env.NODE_ENV == 'development';
    jsonXml.krpano._logkey = process.env.NODE_ENV == 'development';
    return jsonXml;
  },

  getSceneXml(data) {
    let info = data.info || {};
    let fov = info.fov || [];
    let hlookat = info.hlookat || [];
    let vlookat = info.vlookat || [];
    return {
      _name: 'scene_' + data.id,
      _title: data.name,
      _havevrimage: 'true',
      _heading: '0.0',
      _thumburl: '',
      // _autoload: true,
      view: {
        _hlookatmin: hlookat[0] || -180,
        _hlookat: hlookat[1] || 0,
        _ohlookat: hlookat[1] || 0,
        _hlookatmax: hlookat[2] || 180,
        _vlookatmin: vlookat[0] || -90,
        _vlookat: vlookat[1] || 0,
        _ovlookat: vlookat[1] || 0,
        _vlookatmax: vlookat[2] || 90,
        _fovtype: 'MFOV',
        _fovmin: fov[0] || 30,
        _fov: fov[1] || 95,
        _fovmax: fov[2] || 140,
        _limitview: 'fullrage',
      },
      preview: {
        _url: data.preview,
      },
      image: {
        cube: {
          _url: data.path + '/%s/l%l/%v/l%l_%s_%v_%h.jpg',
          _multires: data.resolution || '512,640,1280',
        },
      },
    };
  },

  getHsXml(data) {
    return data.map((item) => {
      let name = `hotsport_${item.id}`;
      let scale = Vue.prototype.isMobile ? item.mScale : item.scale;
      let fontSize = Vue.prototype.isMobile ? item.mFontSize : item.fontSize;
      item.ext = item.ext || {};
      const iconTxtBgColor = item.ext.iconTxtBgColor;
      let bgcolor = '';
      let bgalpha = '1';
      if(iconTxtBgColor){
        if(iconTxtBgColor.includes('rgba')){
          const color = utils.rgbaTo16(iconTxtBgColor);
          bgcolor = color.color;
          bgalpha = color.opacity;
        }else{
          bgcolor = iconTxtBgColor.replace('#', '0x')
        }
      }else{
        bgalpha = ''
      }
      if (item.imageType == 4) {
        return {
          _name: name,
          _type: 'text',
          _html: item.title,
          _renderer: 'css3d',
          _css: `color:${item.ext.iconTxtColor};padding:${item.ext.iconTxtPadding}px;font-size:${fontSize}px`,
          _bgcolor: bgcolor,
          _bgalpha: bgalpha,
          _bgroundedge: item.ext.iconTxtRadius,
          _ath: item.ath,
          _atv: item.atv,
          _distorted: !!item.ext.distorted,
          _onclick: `js(krpjs.handleClickHotspot(${item.id}))`,
        };
      }
      return {
        _name: name,
        _url: item.imagePreview,
        _ath: item.ath,
        _atv: item.atv,
        _height: item.height,
        _width: item.width,
        _tx: item.ext.tx || 0,
        _ty: item.ext.ty || 0,
        _tz: item.ext.tz || 0,
        _rx: item.ext.rx || 0,
        _rotationorder: item.ext.rotationorder || 'xyz',
        _distorted: !!item.ext.distorted,
        _depth: !isNaN(item.ext.depth) ? item.ext.depth : 1000,
        _scale: scale,
        _alpha: item.opacity,
        _onover: `tween(alpha,1)`,
        _onout: `tween(alpha,0.7)`,
        _onloaded: item.imageType == 1 ? `do_crop_animation(${item.width},${item.height},40);` : '',
        _onclick: `js(krpjs.handleClickHotspot(${item.id}))`,
      };
    });
  },

  getHsPlaceholderXml(data) {
    let names = data
      .filter((item) => item.imageType == 5)
      .map((item) => `hotsport_${item.id}_desc`)
      .join('-');
    return data
      .filter((item) => item.imageType != 3)
      .map((item) => {
        let name = `hotsport_${item.id}_placeholder`;
        let scale = Vue.prototype.isMobile ? item.mScale : item.scale;
        let click =
          item.imageType == 5
            ? `showHsDesc(${names},hotsport_${item.id}_desc)`
            : `js(krpjs.handleClickHotspot(${item.id}))`;
        return {
          _name: name,
          _type: 'text',
          _ath: item.ath,
          _atv: item.atv,
          _height: item.height * scale,
          _width: item.width * scale,
          _bgalpha: 0,
          _onover: `set(layer[hotsport_${item.id}_desc].visible,true)`,
          _onout: `set(layer[hotsport_${item.id}_desc].visible,false)`,
          _onclick: click,
        };
      });
  },

  //json-scene-hotspot-layer-title
  getHsTitleXml(data) {
    let names = data
      .filter((item) => item.imageType == 5)
      .map((item) => `hotsport_${item.id}_desc`)
      .join('-');
    return data
      .filter((item) => item.imageType != 3)
      .map((item) => {
        let click =
          item.imageType == 5
            ? `showHsDesc(${names},hotsport_${item.id}_desc)`
            : `js(krpjs.handleClickHotspot(${item.id}))`;
        if (item.imageType == 4) {
          return {};
        }
        let name = `hotsport_${item.id}`;
        let fontSize = Vue.prototype.isMobile ? item.mFontSize : item.fontSize;
        let color = item.imageType == 5 ? '#449854' : '#fff';
        let shadow = item.imageType == 5 ? '1px 1px 1px #fff' : '2px 2px 4px #000';
        return {
          _name: `${name}_title`,
          _type: 'text',
          _html: item.title,
          _align: 'top',
          _edge: 'bottom',
          _ath: item.ath,
          _atv: item.atv,
          _oy: 0,
          _visible: item.isShowTitle === 1,
          _css: `font-size:${fontSize}px;  color:${color};text-shadow: ${shadow};`,
          _bgalpha: 0,
          _parent: `hotspot[${name}_placeholder]`,
          _onclick: click,
        };
      });
  },

  getHsDescXml(data) {
    return data
      .filter((item) => item.imageType == 5)
      .map((item) => {
        let name = `hotsport_${item.id}`;
        return {
          _name: `${name}_desc`,
          _type: 'text',
          _html: item.ext.positionDesc,
          _align: 'bottom',
          _edge: 'top',
          _oy: 5,
          _visible: 'false',
          _width: 200,
          _bgalpha: 0,
          _css: `background:rgba(255,255,255,0.7);padding:5px 10px;text-align:justify;`,
          _parent: `hotspot[${name}_placeholder]`,
        };
      });
  },

  //json-polyline-data
  getPolylineXml(data) {
    return data.map((item) => {
      return {
        _name: `polyline_${item.id}`,
        _type: 'image',
        _url: '',
        _keep: false,
        _visible: true,
        _zoom: false,
        _distorted: false,
        _borderwidth: item.ext && item.ext.width ? item.ext.width : 2,
        _bordercolor: item.ext && item.ext.color ? item.ext.color.replace('#', '0x') : '0xf00f00',
        _polyline: true,
        _enabled: false,
        _handcursor: false,
        point: item.pointData.map((item) => ({ _ath: item.ath, _atv: item.atv })),
        _onloaded: 'trace(11111)',
      };
    });
  },

  renderPolyline(krp, row, index) {
    let name = `polyline_${row.id}`;
    const ext = typeof row.ext === 'string' && row.ext.length ? JSON.parse(row.ext) : row.ext;
    const krpano = krp.get('global');
    var hs = krpano.addhotspot(name);

    krp.call(`set(hotspot[${name}].borderwidth,${ext && ext.width ? ext.width : 2});`);
    krp.call(
      `set(hotspot[${name}].bordercolor,${
        ext && ext.color ? ext.color.replace('#', '0x') : '0xf00f00'
      });`
    );

    krp.call(`set(hotspot[${name}].polyline,true);`);
    krp.call(`set(hotspot[${name}].enabled,false);`);
    krp.call(`set(hotspot[${name}].handcursor,false);`);
    krp.call(`set(hotspot[${name}].renderer,css3d);`);
    row.pointData.forEach((point, pointIndex) => {
      krp.call(`set(hotspot[${name}].point[${pointIndex}].ath,${point.ath});`);
      krp.call(`set(hotspot[${name}].point[${pointIndex}].atv,${point.atv});`);
    });

    let timer = 0;

    if (ext.dotted === 1) {
      timer = setInterval(() => {
        if (hs.sprite && hs.sprite.parentElement) {
          const polyline = hs.sprite.parentElement.querySelectorAll('svg polyline');
          polyline[index].setAttribute('stroke-dasharray', '5,5');
          clearTimeout(timer);
        }
      }, 100);
    }

    if (ext && ext.isLine && ext.arrow === 1) {
      row.pointData.forEach((point, pointIndex) => {
        const nameArrow = `${name}_arrow_${pointIndex}`;
        const borderWidth = 4 + Number(ext.width);
        krp.call(`addhotspot(${nameArrow});`);
        krp.call(`set(hotspot[${nameArrow}].type,text);`);
        krp.call(`set(hotspot[${nameArrow}].html,'');`);
        krp.call(`set(hotspot[${nameArrow}].renderer,css3d);`);
        krp.call(`set(hotspot[${nameArrow}].edge,center);`);
        ext.rotate &&
          krp.call(`set(hotspot[${nameArrow}].rotate,${pointIndex * 180 + ext.rotate});`);
        krp.call(
          `set(hotspot[${nameArrow}].css,width:0;height:0;border-top:${borderWidth}px solid transparent;border-bottom:${borderWidth}px solid transparent;border-right:${borderWidth}px solid ${ext.color};`
        );
        krp.call(`set(hotspot[${nameArrow}].bgalpha,0);`);
        krp.call(`set(hotspot[${nameArrow}].ath,${point.ath});`);
        krp.call(`set(hotspot[${nameArrow}].atv,${point.atv});`);
      });
    }
  },

  //load-xml
  loadPanoXml(krp, jsonXml, blend, flags, loaddone, data) {
    const krpano = krp.get('global');
    let xml = x2js.json2xml_str(jsonXml);
    krpano.actions.loadxml(xml, null, flags, blend, () => {
      // data.extra.pointList.forEach((item) => {
      //   this.renderPolyline(krp, item);
      // });
      krpano.call(loaddone);
    });
    krpano.events.onloadcomplete = () => {
      data.extra.pointList.forEach((item, index) => {
        this.renderPolyline(krp, item, index);
      });
    };
  },
};
